import css from "styled-jsx/css";
import { MOBILE_QUERY_MAX_WIDTH } from "/constants/vp-sizes";

export default css.global`
  .two-columns-with-carousel {
    &.with-signup {
      min-height: calc(100vh - 50px);
    }

    &:not(.with-signup) {
      min-height: calc(90vh);
    }

    min-height: 500px;
    display: flex;
    flex-direction: column;

    .top-line {
      flex: 1 0 auto;
      display: flex;

      .content-column {
        flex: 0 0 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        .content-inner {
          width: 80%;

          .content-title {
            font-size: 3vw;
            margin-bottom: 20px;
            font-weight: 300;

            &.bold {
              font-weight: bold;
            }
          }

          .content-body {
            :global(div),
            :global(li) {
              font-size: 1.3vw;
              font-weight: 300;
              line-height: 1.6;
              margin-bottom: 10px;
            }
          }

          .button-link-wrapper {
            margin-top: 40px;
          }
        }
      }

      .asset-column {
        flex: 0 0 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        .asset-inner {
          width: 80%;
          position: relative;

          :global(.main-image) {
            width: 100%;
            display: flex;
          }
          .main-image.round {
            border-radius: 50%;
          }

          :global(iframe) {
            width: 100%;
          }
        }

        .hot-dog {
          position: absolute;
          width: 60vw;
          height: 26vw;
          background: orange;
          right: -20vw;
          border-radius: 15vw;
          transform: rotate(-20deg);
          top: 25px;
        }

        &.with-shadow {
          .asset-inner {
            box-shadow: 0px 2px 20px 1px rgba(177, 177, 177, 0.4);
          }
        }
      }
    }

    &.asset-left {
      .top-line {
        flex-direction: row-reverse;

        .asset-column {
          .hot-dog {
            right: auto;
            left: -20vw;
            transform: rotate(-20deg);
            top: 120px;
          }
        }
      }
    }

    .bottom-line {
      height: 20vh;
      flex: 0 0 auto;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;

      .signup-title {
        font-size: 1.5vw;
        font-weight: 400;
        margin-bottom: 16px;
      }
    }

    @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
      height: auto;
      margin-top: 40px;

      .top-line {
        flex-direction: column !important;
        min-height: 680px;

        .content-column {
          .content-inner {
            .content-title {
              font-size: 1.375rem;
            }

            .content-body {
              :global(div),
              :global(li) {
                font-size: 0.875rem;
              }
            }
          }
        }

        .asset-column {
          min-height: 100vw;

          .hot-dog {
            width: 130vw;
            height: 60vw;
            border-radius: 30vw;
            right: -40vw;
          }
        }
      }

      .bottom-line {
        height: auto;

        .signup-title {
          padding: 0px 20px;
          font-size: 0.875rem;
        }
      }

      &.asset-left {
        .top-line {
          .asset-column {
            .hot-dog {
              right: auto;
              left: -40vw;
            }
          }
        }
      }
    }
  }
`;
